<script lang="ts">
  import {
    isOtherActivitiesWindowOpen,
    selectedOtherActivity,
    selectedActivityIndex,
  } from "../store/AppState";
  import { toggleMute } from "../utils/AudioManager";
  import {
    sendInteractionEvent,
    INTERACTION_TYPE_SOUND,
  } from "../utils/analytics";

  export let mobile: boolean = false;

  const handleSoundClick = () => {
    soundActive = !soundActive;
    toggleMute();
    sendInteractionEvent(INTERACTION_TYPE_SOUND, "zvuk");
  };
  const handleOtherClick = () => {
    if ($selectedOtherActivity !== null) {
      $selectedOtherActivity = null;
      return;
    } else {
      $isOtherActivitiesWindowOpen = !$isOtherActivitiesWindowOpen;
    }
  };

  let soundActive = true;

  const paddingLeft = mobile ? "1.25rem" : "auto";
  const left = mobile ? "0" : "auto";
  $: background =
    mobile && !$isOtherActivitiesWindowOpen && $selectedActivityIndex === null
      ? "hsla(208, 42%, 17%, 0.6)"
      : "auto";
</script>

<div
  class="nav-controls"
  style={`top: ${
    __MODE__ === "production" ? "6.4rem" : "0"
  }; left: ${left}; padding-left: ${paddingLeft}; background: ${background}; z-index: ${
    mobile ? "10001" : "100001"
  }`}
>
  <button on:pointerup={handleSoundClick} style={`order: ${mobile ? "2" : "1"}`}
    ><img
      src={`${__PUBLIC_PATH__}images/icon-sound.svg`}
      alt="sound-icon"
      style={`opacity: ${soundActive ? "1" : "0.3"};`}
    /></button
  >
  <button on:pointerup={handleOtherClick} style={`order: ${mobile ? "1" : "2"}`}
    ><img
      src={`${__PUBLIC_PATH__}images/icon-more.svg`}
      alt="other-icon"
      style={`opacity: ${
        !$isOtherActivitiesWindowOpen || $selectedOtherActivity !== null
          ? "1"
          : "0.3"
      };`}
    /></button
  >
</div>

<style>
  .nav-controls {
    padding-top: 1.25rem;
    position: fixed;
    right: 0;
    padding-bottom: 1.25rem;
    padding-right: 1.25rem;
    display: flex;
    gap: 1.25rem;
    justify-content: space-between;
  }

  .nav-controls button {
    all: unset;
    cursor: pointer;
  }
</style>
